// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userpic[data-v-23e8662b] {\n  width: 34px;\n  height: 34px;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n  cursor: pointer;\n}\n.userpic img[data-v-23e8662b] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    -o-object-position: center;\n       object-position: center;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
